var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center"},[_c('font-awesome-icon',{attrs:{"icon":"info-circle"}}),_vm._v(" "+_vm._s(_vm.message || "Aucun résultat n'est pour le moment disponible.")+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }